import { render, staticRenderFns } from "./PreChatForm.vue?vue&type=template&id=c56052de&scoped=true&"
import script from "./PreChatForm.vue?vue&type=script&lang=js&"
export * from "./PreChatForm.vue?vue&type=script&lang=js&"
import style0 from "./PreChatForm.vue?vue&type=style&index=0&id=c56052de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56052de",
  null
  
)

export default component.exports